export default function hideSaveDiscardButtons(currentSubcategory) {
    return currentSubcategory.options.reduce(function (state, option) {
        return state &&
            !!option.fullOptionFormSettings.hideSaveDiscard &&
            option.fullOptionFormSettings.hideSaveDiscard();
    }, true);
}
//# sourceMappingURL=hideSaveDiscardButtons.js.map